var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconProjectPlusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8335 62.5H46.1668V45.8333H62.8335V37.5H46.1668V20.8333H37.8335V37.5H21.1668V45.8333H37.8335V62.5ZM42.0002 83.3333C36.2363 83.3333 30.8196 82.2396 25.7502 80.0521C20.6807 77.8646 16.271 74.8958 12.521 71.1458C8.771 67.3958 5.80225 62.9861 3.61475 57.9167C1.42725 52.8472 0.333496 47.4305 0.333496 41.6667C0.333496 35.9028 1.42725 30.4861 3.61475 25.4167C5.80225 20.3472 8.771 15.9375 12.521 12.1875C16.271 8.4375 20.6807 5.46875 25.7502 3.28125C30.8196 1.09375 36.2363 0 42.0002 0C47.764 0 53.1807 1.09375 58.2502 3.28125C63.3196 5.46875 67.7293 8.4375 71.4793 12.1875C75.2293 15.9375 78.1981 20.3472 80.3856 25.4167C82.5731 30.4861 83.6668 35.9028 83.6668 41.6667C83.6668 47.4305 82.5731 52.8472 80.3856 57.9167C78.1981 62.9861 75.2293 67.3958 71.4793 71.1458C67.7293 74.8958 63.3196 77.8646 58.2502 80.0521C53.1807 82.2396 47.764 83.3333 42.0002 83.3333ZM42.0002 75C51.3057 75 59.1877 71.7708 65.646 65.3125C72.1043 58.8542 75.3335 50.9722 75.3335 41.6667C75.3335 32.3611 72.1043 24.4792 65.646 18.0208C59.1877 11.5625 51.3057 8.33333 42.0002 8.33333C32.6946 8.33333 24.8127 11.5625 18.3543 18.0208C11.896 24.4792 8.66683 32.3611 8.66683 41.6667C8.66683 50.9722 11.896 58.8542 18.3543 65.3125C24.8127 71.7708 32.6946 75 42.0002 75Z",
    fill: "#ffffff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectPlusWhite);
export default __webpack_public_path__ + "static/media/icon_project_plus_white.f85ed8ccf34819e6ed006911db7bf892.svg";
export { ForwardRef as ReactComponent };